import * as ACTION_TYPES from "./actionTypes";

export const initialState = {
    isLoading: false,
    success: false,
    payload: {},
    errors: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CREATE_FORMLAYOUT_JSON: {
            return { ...state, payload: action.data, isLoading: true };
        }
        case ACTION_TYPES.CREATE_FORMLAYOUT_JSON_SUCCESS: {
            return {
                ...state,
                success: true,
                errors: null,
                isLoading: false,
            };
        }
        case ACTION_TYPES.CREATE_FORMLAYOUT_JSON_FAILURE: {
            return {
                ...state,
                success: false,
                errors: action.errors,
                isLoading: false,
            };
        }
        case ACTION_TYPES.REFRESH_REDIS_CACHE: {
            return { ...state, payload: action.data, isLoading: true };
        }
        case ACTION_TYPES.REFRESH_REDIS_CACHE_SUCCESS: {
            return {
                ...state,
                success: true,
                errors: null,
                isLoading: false,
            };
        }
        case ACTION_TYPES.REFRESH_REDIS_CACHE_FAILURE: {
            return {
                ...state,
                success: false,
                errors: action.errors,
                isLoading: false,
            };
        }
        case ACTION_TYPES.REFRESH_ACTION_SCOPES: {
            return { ...state, payload: action.data, isLoading: true };
        }
        case ACTION_TYPES.REFRESH_ACTION_SCOPES_SUCCESS: {
            return {
                ...state,
                success: true,
                errors: null,
                isLoading: false,
            };
        }
        case ACTION_TYPES.REFRESH_ACTION_SCOPES_FAILURE: {
            return {
                ...state,
                success: false,
                errors: action.errors,
                isLoading: false,
            };
        }
        case ACTION_TYPES.RESET_WARRANTIES_REPORT: {
            return {
                ...state,
                success: false,
                errors: null,
                isLoading: false,
                payload: {}
            };
        }
        case ACTION_TYPES.REFRESH_PROPERTY_MANAGER_JSON: {
            return {
                ...state, 
                payload: action.data, 
                isLoading: true 
            };
        }
        case ACTION_TYPES.REFRESH_PROPERTY_MANAGER_JSON_SUCCESS: {
            return {
                ...state,
                success: true,
                errors: null,
                isLoading: false,
            };
        }
        case ACTION_TYPES.REFRESH_PROPERTY_MANAGER_JSON_FAILURE: {
            return {
                ...state,
                success: false,
                errors: action.errors,
                isLoading: false,
            };
        }
        case ACTION_TYPES.API_DEEP_HEALTH_CHECK: {
            return {
                ...state, 
                payload: action.data, 
                isLoading: true 
            };
        }
        case ACTION_TYPES.API_DEEP_HEALTH_CHECK_SUCCESS: {
            return {
                ...state,
                success: true,
                errors: null,
                isLoading: false,
            };
        }
        case ACTION_TYPES.API_DEEP_HEALTH_CHECK_FAILURE: {
            return {
                ...state,
                success: false,
                errors: action.errors,
                isLoading: false,
            };
        }
        default:
            return state;
    }
};

export default reducer;
